import { createContext, useCallback, useContext } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * 多标签页下页面所在标签的「返回」。浏览器历史是所有标签共用的，
 * navigate(-1) 可能退到别的标签，所以在标签里返回走标签自己记的上一页。
 */
export const PageBackContext = createContext<(() => void) | null>(null);

/** 页面里的「返回」按钮用它代替 navigate(-1)。不在标签页里（手机端、平台端）时就是 navigate(-1)。 */
export const usePageBack = () => {
  const tabBack = useContext(PageBackContext);
  const navigate = useNavigate();
  return useCallback(() => (tabBack ? tabBack() : navigate(-1)), [tabBack, navigate]);
};
